"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_STATES = exports.ORDER_FILTERS = exports.FETCHING_JOURNAL_KEY = exports.NUM_429_ERRORS_KEY = exports.NUM_OLD_ARTICLES_KEY = exports.ARTICLE_DATA_FETCHING_RUNTIME_FAST_KEY = exports.ARTICLE_DATA_FETCHING_RUNTIME_MAIN_KEY = exports.NUM_ARTICLES_FETCHED_KEY = exports.ORDER_SIDEBAR_TABS = exports.ORDER_TABS = exports.PricingSettingsTabs = exports.OUTSETA_STAGES = exports.BULL_MQ_KEEP_JOBS_VALUES = exports.sorceryBulkSettings = exports.sorceryBulkSettingsPriceMap = exports.gundamBulkSettings = exports.gundamBulkSettingsPriceMap = exports.cyberpunkBulkSettings = exports.cyberpunkBulkSettingsPriceMap = exports.riftboundBulkSettings = exports.swuBulkSettings = exports.riftboundBulkSettingsPriceMap = exports.swuBulkSettingsPriceMap = exports.bssBulkSettings = exports.bssBulkSettingsPriceMap = exports.lorcanaBulkSettings = exports.lorcanaBulkSettingsPriceMap = exports.onePieceBulkSettings = exports.onePieceBulkSettingsPriceMap = exports.digimonBulkSettings = exports.digimonBulkSettingsPriceMap = exports.FABBulkSettings = exports.FABBulkSettingsPriceMap = exports.WSBulkSettings = exports.WSBulkSettingsPriceMap = exports.FFBulkSettings = exports.FFBulkSettingsPriceMap = exports.DBSBulkSettings = exports.DBSBulkSettingsPriceMap = exports.vanguardBulkSettings = exports.vanguardBulkSettingsPriceMap = exports.pokemonBulkSettings = exports.pokemonBulkSettingsPriceMap = exports.yugiohBulkSettings = exports.yugiohBulkSettingsPriceMap = exports.magicBulkSettings = exports.magicBulkSettingsPriceMap = exports.DAYS_BEFORE_RENEWAL = exports.SUBSCRIPTION_TIERS_NAMES = exports.SUBSCRIPTION_TIERS = void 0;
exports.DEFAULT_SURCHARGE_COUNTRIES = exports.OFFER_COUNTRY_SURCHARGE_PERCENT = exports.PRICING_DEFAULTS = exports.VIDEO_TUTORIALS = exports.TimePreset = exports.ORDER_PROPS = void 0;
var types_1 = require("./types");
exports.SUBSCRIPTION_TIERS = [
    { id: types_1.OutsetaSubscriptionId.Vacation, cost: 0, min: Infinity, max: -Infinity },
    { id: types_1.OutsetaSubscriptionId.Collector, cost: 3, min: 0, max: 100 },
    { id: types_1.OutsetaSubscriptionId.Starter, cost: 10, min: 100, max: 300 },
    { id: types_1.OutsetaSubscriptionId.Trader, cost: 20, min: 300, max: 600 },
    { id: types_1.OutsetaSubscriptionId.Professional, cost: 40, min: 600, max: 1200 },
    { id: types_1.OutsetaSubscriptionId.Shop, cost: 60, min: 1200, max: 2500 },
    { id: types_1.OutsetaSubscriptionId.Powerseller, cost: 80, min: 2500, max: Infinity },
];
exports.SUBSCRIPTION_TIERS_NAMES = (_a = {},
    _a[types_1.OutsetaSubscriptionId.Vacation] = 'Vacation',
    _a[types_1.OutsetaSubscriptionId.Collector] = 'Collector',
    _a[types_1.OutsetaSubscriptionId.Starter] = 'Starter',
    _a[types_1.OutsetaSubscriptionId.Trader] = 'Trader',
    _a[types_1.OutsetaSubscriptionId.Professional] = 'Professional',
    _a[types_1.OutsetaSubscriptionId.Shop] = 'Shop',
    _a[types_1.OutsetaSubscriptionId.Powerseller] = 'Powerseller',
    _a);
exports.DAYS_BEFORE_RENEWAL = 5 * 24 * 60 * 60 * 1000;
exports.magicBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05, foilPrice: 0.1 },
    3: { price: 0.05, foilPrice: 0.1 },
    4: { price: 0.1, foilPrice: 0.25 },
    5: { price: 0.25, foilPrice: 0.5 },
    6: { price: 0.5, foilPrice: 1 },
    7: { price: 1, foilPrice: 2 },
    8: { price: 0.5 },
    9: { price: 1 },
};
exports.magicBulkSettings = {
    _id: String(types_1.IdGame.Magic),
    gameId: types_1.IdGame.Magic,
    name: 'Default ' + types_1.GameName.Magic + ' Minimum Prices',
    priceMap: exports.magicBulkSettingsPriceMap,
};
exports.yugiohBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
    9: { price: 0.25 },
    10: { price: 0.5 },
    11: { price: 0.5 },
    12: { price: 0.5 },
    13: { price: 0.5 },
    14: { price: 0.5 },
    15: { price: 0.5 },
    16: { price: 0.5 },
    17: { price: 0.5 },
    18: { price: 0.5 },
    19: { price: 0.5 },
    20: { price: 1 },
};
exports.yugiohBulkSettings = {
    _id: String(types_1.IdGame.Yugioh),
    gameId: types_1.IdGame.Yugioh,
    name: 'Default ' + types_1.GameName.Yugioh + ' Minimum Prices',
    priceMap: exports.yugiohBulkSettingsPriceMap,
};
exports.pokemonBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.5 },
    7: { price: 1 },
    8: { price: 0.5 },
    9: { price: 1 },
    10: { price: 1 },
    11: { price: 1 },
    12: { price: 1 },
    13: { price: 1 },
};
exports.pokemonBulkSettings = {
    _id: String(types_1.IdGame.Pokemon),
    gameId: types_1.IdGame.Pokemon,
    name: 'Default ' + types_1.GameName.Pokemon + ' Minimum Prices',
    priceMap: exports.pokemonBulkSettingsPriceMap,
};
exports.vanguardBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.5 },
    7: { price: 1 },
    8: { price: 0.5 },
    9: { price: 1 },
    10: { price: 1 },
    11: { price: 1 },
    12: { price: 1 },
    13: { price: 1 },
};
exports.vanguardBulkSettings = {
    _id: String(types_1.IdGame.Vanguard),
    gameId: types_1.IdGame.Vanguard,
    name: 'Default ' + types_1.GameName.Vanguard + ' Minimum Prices',
    priceMap: exports.vanguardBulkSettingsPriceMap,
};
exports.DBSBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25, foilPrice: 0.5 },
    6: { price: 0.5, foilPrice: 1 },
    7: { price: 0.5, foilPrice: 1 },
    8: { price: 0.5, foilPrice: 1 },
    9: { price: 1, foilPrice: 1 },
    10: { price: 1 },
    11: { price: 1 },
    12: { price: 1 },
};
exports.DBSBulkSettings = {
    _id: String(types_1.IdGame.DBS),
    gameId: types_1.IdGame.DBS,
    name: 'Default ' + types_1.GameName.DBS + ' Minimum Prices',
    priceMap: exports.DBSBulkSettingsPriceMap,
};
exports.FFBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.5 },
};
exports.FFBulkSettings = {
    _id: String(types_1.IdGame.FF),
    gameId: types_1.IdGame.FF,
    name: 'Default ' + types_1.GameName.FF + ' Minimum Prices',
    priceMap: exports.FFBulkSettingsPriceMap,
};
exports.WSBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
    9: { price: 0.25 },
    10: { price: 0.5 },
    11: { price: 0.5 },
    12: { price: 0.5 },
    13: { price: 0.5 },
    14: { price: 0.5 },
    15: { price: 0.5 },
    16: { price: 0.5 },
    17: { price: 0.5 },
    18: { price: 0.5 },
    19: { price: 0.5 },
    20: { price: 1 },
    21: { price: 1 },
};
exports.WSBulkSettings = {
    _id: String(types_1.IdGame.WS),
    gameId: types_1.IdGame.WS,
    name: 'Default ' + types_1.GameName.WS + ' Minimum Prices',
    priceMap: exports.WSBulkSettingsPriceMap,
};
exports.FABBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
};
exports.FABBulkSettings = {
    _id: String(types_1.IdGame.FAB),
    gameId: types_1.IdGame.FAB,
    name: 'Default ' + types_1.GameName.FAB + ' Minimum Prices',
    priceMap: exports.FABBulkSettingsPriceMap,
};
exports.digimonBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
};
exports.digimonBulkSettings = {
    _id: String(types_1.IdGame.Digimon),
    gameId: types_1.IdGame.Digimon,
    name: 'Default ' + types_1.GameName.Digimon + ' Minimum Prices',
    priceMap: exports.digimonBulkSettingsPriceMap,
};
exports.onePieceBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.15 },
    6: { price: 0.15 },
    7: { price: 0.25 },
    8: { price: 0.25 },
    9: { price: 0.25 },
    10: { price: 10 },
    11: { price: 5 },
};
exports.onePieceBulkSettings = {
    _id: String(types_1.IdGame.OnePiece),
    gameId: types_1.IdGame.OnePiece,
    name: 'Default ' + types_1.GameName.OnePiece + ' Minimum Prices',
    priceMap: exports.onePieceBulkSettingsPriceMap,
};
exports.lorcanaBulkSettingsPriceMap = {
    1: { price: 0.05, foilPrice: 1 },
    2: { price: 0.05, foilPrice: 2 },
    3: { price: 0.1, foilPrice: 4 },
    4: { price: 0.1, foilPrice: 4 },
    5: { price: 0.25, foilPrice: 8 },
    6: { price: 0.5 },
    7: { price: 0.5 },
    8: { price: 10 },
    9: { price: 10 },
    10: { price: 20 },
};
exports.lorcanaBulkSettings = {
    _id: String(types_1.IdGame.Lorcana),
    gameId: types_1.IdGame.Lorcana,
    name: 'Default ' + types_1.GameName.Lorcana + ' Minimum Prices',
    priceMap: exports.lorcanaBulkSettingsPriceMap,
};
// BSS
exports.bssBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.1 },
    5: { price: 0.25 },
    6: { price: 0.25 },
    7: { price: 0.25 },
    8: { price: 0.5 },
    9: { price: 0.5 },
    10: { price: 0.5 },
};
exports.bssBulkSettings = {
    _id: String(types_1.IdGame.BSS),
    gameId: types_1.IdGame.BSS,
    name: 'Default ' + types_1.GameName.BSS + ' Minimum Prices',
    priceMap: exports.bssBulkSettingsPriceMap,
};
// SWU
exports.swuBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.5 },
    5: { price: 1.0 },
};
// Riftbound
exports.riftboundBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1 },
    4: { price: 0.5 },
    5: { price: 1.0 },
};
exports.swuBulkSettings = {
    _id: String(types_1.IdGame.SWU),
    gameId: types_1.IdGame.SWU,
    name: 'Default ' + types_1.GameName.SWU + ' Minimum Prices',
    priceMap: exports.swuBulkSettingsPriceMap,
};
exports.riftboundBulkSettings = {
    _id: String(types_1.IdGame.Riftbound),
    gameId: types_1.IdGame.Riftbound,
    name: 'Default ' + types_1.GameName.Riftbound + ' Minimum Prices',
    priceMap: exports.riftboundBulkSettingsPriceMap,
};
// Cyberpunk
exports.cyberpunkBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.05 },
    3: { price: 0.1, foilPrice: 0.25 },
    4: { price: 0.5, foilPrice: 1 },
    5: { price: 1.0, foilPrice: 2 },
    6: { price: 1.0, foilPrice: 2 },
    7: { price: 1.0, foilPrice: 2 },
};
exports.cyberpunkBulkSettings = {
    _id: String(types_1.IdGame.Cyberpunk),
    gameId: types_1.IdGame.Cyberpunk,
    name: 'Default ' + types_1.GameName.Cyberpunk + ' Minimum Prices',
    priceMap: exports.cyberpunkBulkSettingsPriceMap,
};
// Gundam
exports.gundamBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.1 },
    3: { price: 0.05 },
    4: { price: 0.1 },
    5: { price: 0.1 },
    6: { price: 0.25 },
    7: { price: 0.5 },
    8: { price: 1 },
    9: { price: 2 },
    10: { price: 2 },
    11: { price: 0.05 },
    12: { price: 0.1 },
    13: { price: 0.25 },
    14: { price: 0.05 },
};
exports.gundamBulkSettings = {
    _id: String(types_1.IdGame.Gundam),
    gameId: types_1.IdGame.Gundam,
    name: 'Default ' + types_1.GameName.Gundam + ' Minimum Prices',
    priceMap: exports.gundamBulkSettingsPriceMap,
};
// Sorcery
exports.sorceryBulkSettingsPriceMap = {
    1: { price: 0.05 },
    2: { price: 0.1 },
    3: { price: 0.25 },
    4: { price: 0.5 },
    5: { price: 0.25 },
    6: { price: 0.05 },
};
exports.sorceryBulkSettings = {
    _id: String(types_1.IdGame.Sorcery),
    gameId: types_1.IdGame.Sorcery,
    name: 'Default ' + types_1.GameName.Sorcery + ' Minimum Prices',
    priceMap: exports.sorceryBulkSettingsPriceMap,
};
exports.BULL_MQ_KEEP_JOBS_VALUES = {
    age: 60 * 60 * 12,
    count: 100,
};
exports.OUTSETA_STAGES = {
    2: 'Trialing',
    3: 'Subscribing',
    4: 'Cancelling',
    5: 'Expired',
    6: 'TrialExpired',
    7: 'PastDue',
};
var PricingSettingsTabs;
(function (PricingSettingsTabs) {
    PricingSettingsTabs[PricingSettingsTabs["BulkSettings"] = 0] = "BulkSettings";
    PricingSettingsTabs[PricingSettingsTabs["Competitors"] = 1] = "Competitors";
    PricingSettingsTabs[PricingSettingsTabs["Strategies"] = 2] = "Strategies";
})(PricingSettingsTabs = exports.PricingSettingsTabs || (exports.PricingSettingsTabs = {}));
exports.ORDER_TABS = [
    {
        states: '',
        filters: [
            'pending',
            'paid',
            'picking',
            'picked',
            'packed',
            'sent',
            'issues',
            'cancelled',
            'sealed',
            'presale',
        ],
    },
    {
        states: ['paid', 'picking'],
        filters: ['paid', 'picking', 'issues', 'sealed', 'presale'],
    },
    { states: ['picking', 'picked'], filters: ['picking', 'picked'] },
    {
        states: ['picked', 'packed', 'sent'],
        filters: ['picked', 'packed', 'sent', 'issues', 'sealed', 'presale'],
    },
    { states: ['received', 'evaluated'], filters: ['received', 'evaluated'] },
    { states: [], filters: [] },
];
exports.ORDER_SIDEBAR_TABS = {
    FULFILMENT_CENTER: 0,
    MANAGE_PICKING_LISTS: 1,
    PICK_ARTICLES: 2,
    PACKAGE: 3,
    COMPLETED: 4,
    CARDMARKET_SALES: 5,
};
exports.NUM_ARTICLES_FETCHED_KEY = 'numArticlesFetched';
exports.ARTICLE_DATA_FETCHING_RUNTIME_MAIN_KEY = 'articleDataFetchingRuntimeMain';
exports.ARTICLE_DATA_FETCHING_RUNTIME_FAST_KEY = 'articleDataFetchingRuntimeFast';
exports.NUM_OLD_ARTICLES_KEY = 'numOldArticles';
exports.NUM_429_ERRORS_KEY = 'num429Errors';
exports.FETCHING_JOURNAL_KEY = 'fj';
exports.ORDER_FILTERS = [
    {
        name: 'all',
        state: 'all',
        label: 'All',
        boxColor: '#0019a2',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'pending',
        state: 'bought',
        label: 'Pending',
        boxColor: '#b6cc34',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'paid',
        state: 'paid',
        label: 'Paid',
        boxColor: '#70bf4c',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'picking',
        state: 'picking',
        label: 'Picking',
        boxColor: '#00bbbe',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'picked',
        state: 'picked',
        label: 'Picked',
        boxColor: '#00a0dc',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'packed',
        state: 'packed',
        label: 'Packed',
        boxColor: '#0079b2',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'sent',
        state: 'sent',
        label: 'Sent',
        boxColor: '#006898',
        textColor: 'white',
        defaultActive: true,
    },
    {
        name: 'received',
        state: 'received',
        label: 'Received',
        boxColor: '#77FF94',
        textColor: 'black',
        defaultActive: true,
    },
    {
        name: 'evaluated',
        state: 'evaluated',
        label: 'Evaluated',
        boxColor: '#77FF94',
        textColor: 'black',
        defaultActive: true,
    },
    {
        name: 'messages',
        state: 'messages',
        label: 'Messages',
        boxColor: '#FFE15D',
        textColor: 'black',
        defaultActive: false,
    },
    {
        name: 'issues',
        state: 'issues',
        label: 'Issues',
        boxColor: '#f15e3e',
        textColor: 'white',
        defaultActive: false,
    },
    {
        name: 'cancelled',
        state: 'cancelled',
        label: 'Cancelled',
        boxColor: '#f1973e',
        textColor: 'white',
        defaultActive: false,
    },
    {
        name: 'magic',
        state: 'Magic',
        label: 'Magic',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'yugioh',
        state: 'Yugioh',
        label: 'Yugioh',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'pokemon',
        state: 'Pokemon',
        label: 'Pokemon',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'vanguard',
        state: 'Vanguard',
        label: 'Vanguard',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'ff',
        state: 'FF',
        label: 'FF',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'dbs',
        state: 'DBS',
        label: 'DBS',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'ws',
        state: 'WS',
        label: 'WS',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'fab',
        state: 'FAB',
        label: 'FAB',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'digimon',
        state: 'Digimon',
        label: 'Digimon',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'onepiece',
        state: 'OnePiece',
        label: 'OnePiece',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'lorcana',
        state: 'Lorcana',
        label: 'Lorcana',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'bss',
        state: 'BSS',
        label: 'BSS',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'swu',
        state: 'SWU',
        label: 'SWU',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'riftbound',
        state: 'Riftbound',
        label: 'Riftbound',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'gundam',
        state: 'Gundam',
        label: 'Gundam',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'sorcery',
        state: 'Sorcery',
        label: 'Sorcery',
        boxColor: '',
        textColor: '',
        defaultActive: true,
        isGame: true,
    },
    {
        name: 'sealed',
        state: 'sealed',
        label: 'Sealed',
        boxColor: '#d49c00',
        textColor: 'white',
        defaultActive: false,
    },
    {
        name: 'presale',
        state: 'presale',
        label: 'Presale',
        boxColor: '#8365db',
        textColor: 'white',
        defaultActive: false,
    },
];
exports.ORDER_STATES = [
    {
        name: 'bought',
        label: 'Bought',
        boxColor: '#b6cc34',
        textColor: 'white',
    },
    {
        name: 'paid',
        label: 'Paid',
        boxColor: '#70bf4c',
        textColor: 'white',
    },
    {
        name: 'picking',
        label: 'Picking',
        boxColor: '#00bbbe',
        textColor: 'white',
    },
    {
        name: 'picked',
        label: 'Picked',
        boxColor: '#00a0dc',
        textColor: 'white',
    },
    {
        name: 'packed',
        label: 'Packed',
        boxColor: '#0079b2',
        textColor: 'white',
    },
    {
        name: 'cancellationRequested',
        label: 'Cancelling',
        boxColor: '',
        textColor: '',
    },
    {
        name: 'cancelled',
        label: 'Cancelled',
        boxColor: '#f1973e',
        textColor: 'white',
    },
    {
        name: 'sent',
        label: 'Sent',
        boxColor: '#006898',
        textColor: 'white',
    },
    {
        name: 'lost',
        label: 'Lost',
        boxColor: '',
        textColor: '',
    },
    {
        name: 'received',
        label: 'Received',
        boxColor: '#3581B8',
        textColor: 'white',
    },
    {
        name: 'evaluated',
        label: 'Evaluated',
        boxColor: '#5AA9E6',
        textColor: 'white',
    },
];
exports.ORDER_PROPS = [
    {
        name: 'issues',
        label: 'issues',
        boxColor: '#f15e3e',
        textColor: 'white',
    },
];
exports.TimePreset = {
    ONE_MINUTE: 60,
    ONE_HOUR: 60 * 60,
    ONE_DAY: 60 * 60 * 24,
};
exports.VIDEO_TUTORIALS = [
    {
        title: 'manualSinglesAdd',
        videoId: 'JLHTtC-q_DU',
    },
    {
        title: 'csvImportSingles',
        videoId: 'RpfJhHrsqtY',
    },
    {
        title: 'manualAccessoriesAdd',
        videoId: 'UUR038Po8FE',
    },
    {
        title: 'csvImportAccessories',
        videoId: 'sdYhGi6p0So',
    },
    {
        title: 'priceSettings',
        videoId: 'sD0bH9TsfcM',
    },
    {
        title: 'collectionAppraisal',
        videoId: '_xiEYF8x7-g',
    },
    {
        title: 'pricingBot',
        videoId: '94-W5cOrrNs',
    },
    {
        title: 'orderManagement',
        videoId: 'ZAQaGWMfQDk',
    },
];
exports.PRICING_DEFAULTS = {
    maxDecrease: 5,
    maxIncrease: 100,
};
// Percentage added to an offer's price when its seller is located in one of the
// AutopricingAssignment.surchargeCountries.
exports.OFFER_COUNTRY_SURCHARGE_PERCENT = 25;
// Default surcharge countries applied to autopricing requests that don't specify
// their own list. Cardmarket seller.country codes: GB = United Kingdom,
// NO = Norway, CH = Switzerland.
exports.DEFAULT_SURCHARGE_COUNTRIES = ['GB', 'NO', 'CH'];
//# sourceMappingURL=constants.js.map